export function groupIsReady (group) {
  return !!(group && group.ship_via)
}

export function initialActiveGroupId (groups) {
  if (!groups.length) return ''
  const incomplete = groups.find(group => !groupIsReady(group))
  return (incomplete || groups[0]).id
}

export function reconcileActiveGroup (groups, activeId, previousIndex) {
  if (!groups.length) return { id: '', index: 0 }
  const currentIndex = groups.findIndex(group => group.id === activeId)
  if (currentIndex >= 0) return { id: activeId, index: currentIndex }
  const safeIndex = Math.max(0, Math.min(previousIndex || 0, groups.length - 1))
  return { id: groups[safeIndex].id, index: safeIndex }
}

export function adjacentGroupId (groups, activeId, direction) {
  const index = groups.findIndex(group => group.id === activeId)
  const nextIndex = index + direction
  return nextIndex >= 0 && nextIndex < groups.length ? groups[nextIndex].id : activeId
}

export function displayQuotedTotal (value, blocked, formatter) {
  if (blocked || value === null || value === undefined || value === '') {
    return blocked ? 'Needs pricing review' : 'Unavailable'
  }
  return formatter(value)
}

export function dedupePricingIssues (issues) {
  const seen = new Set()
  return (issues || []).filter(issue => {
    const message = issue && issue.message ? issue.message : 'Required pricing configuration could not be resolved.'
    if (seen.has(message)) return false
    seen.add(message)
    return true
  })
}

export function pluralizeCount (count, singular, plural) {
  const numericCount = parseInt(count || 0, 10) || 0
  return numericCount + ' ' + (numericCount === 1 ? singular : (plural || singular + 's'))
}

export function limitedChips (items, label, limit = 3) {
  const chips = (items || []).slice(0, limit).map(label)
  const remaining = Math.max(0, (items || []).length - limit)
  if (remaining) chips.push('+' + remaining + ' more')
  return chips
}

export function selectedItemsAmount (items) {
  return (items || []).reduce((total, item) => {
    const raw = item.total_price !== undefined && item.total_price !== null
      ? item.total_price
      : (item.amount !== undefined && item.amount !== null ? item.amount : item.price)
    return total + (parseFloat(raw || 0) || 0)
  }, 0)
}

export function selectedRoyaltyRates (items) {
  return Array.from(new Set((items || []).map(item => {
    const rate = item.rate !== undefined && item.rate !== null
      ? item.rate
      : (item.royalty_rate !== undefined && item.royalty_rate !== null ? item.royalty_rate : item.price)
    return rate === undefined || rate === null || rate === '' ? '' : String(rate)
  }).filter(Boolean)))
}
